import {Component, EventEmitter, Injector, OnInit, Output} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap/modal';
import {ModalBaseComponent} from '../modal-base-component';
import {CARDGROUPINFO, RESPONSEITEM} from '../../../../gen/swagger-api';
import {AlertService} from '../../../shared/services/alert.service';
import {ErrorHandlingService} from '../../../shared/services/error-handling-service';
import {DefaultService} from "../../../../gen/swagger-api/api/default.service";
import {toInt} from "ngx-bootstrap/chronos/utils/type-checks";

const bigInt = require('big-integer');

@Component({
  selector: 'app-selection-operation-modal',
  templateUrl: './selection-operation-modal.component.html',
  styleUrls: ['./selection-operation-modal.component.css']
})
export class SelectionOperationModalComponent extends ModalBaseComponent implements OnInit {

  private defaultService: DefaultService;
  public title: string;
  public subtitle: string;
  public selection: number; // 0 - Selection from Content browser, 1 - Define range, 2 - upload via file
  public operation = '';
  public cards: Array<string>;
  public step = 'step1';
  public cardGroups: Array<CARDGROUPINFO> = [];
  public selectedCardGroup: any;
  public sourceCard: CARDGROUPINFO;
  public rangeViccid: string;
  public rangeQuantity: number;
  public menu: string; // CARD - for card Groups.  SUBSCIPTION - for subscrition pools;
  public idName = 'Veis';
  public importIds: string;
  @Output() action = new EventEmitter();
  private fileText: String;
  public errorResponse: Array<RESPONSEITEM>;
  public showICCIDConsistOnlyNumbersError = false;
  public showCardGroupSelectedError = false;
  public showUploadFileError = false;
  public showQuantityError = false;
  public uploaded = false;
  private alertService: AlertService;

  constructor(private inject: Injector, private _bsModalRef: BsModalRef, defaultService: DefaultService,
              alertService: AlertService,
              private errorHandlingService: ErrorHandlingService) {
    super(inject);
    this.defaultService = defaultService;
    this.alertService = alertService;
  }

  ngOnInit(): void {
    if (this.cards.length === 0) {
      this.selection = 1;
      this.subtitle = 'Define range';
    } else {
      this.selection = 0;
      this.subtitle = 'Use selection from content browser';
    }
    var offset = 0;
    var limit = 100000;
    this.defaultService.cardGroupsGet(offset,limit).subscribe(cardGroups => {
        this.cardGroups = cardGroups;
      },
      (error) => {
        console.log(error);
        this.errorHandlingService.errorHandling(error);
      });

    if (this.menu === 'CARD') {
      this.idName = 'eis';
    }
  }

  public setSelection(value: number) {
    this.selection = value;
    if (value === 0) {
      this.subtitle = 'Use selection from content browser';
    } else if (value === 1) {
      this.subtitle = 'Define range';
    } else if (value === 2) {
      this.subtitle = 'Upload file with list';
    }
  }

  // call this whenever you want to close modal
  public closeModal(): void {
    this._bsModalRef.hide();
  }

  public delete(): void {
    this.cards.forEach(item => {
      this.defaultService.cardsEidOrIccidDelete(item).subscribe();
    });
    this.action.emit(true);
    this._bsModalRef.hide();
  }

  public next() {
    this.step = 'step2';
    this.showCardGroupSelectedError = false;
    this.showICCIDConsistOnlyNumbersError = false;
    this.showUploadFileError = false;
    this.showQuantityError = false;
  }

  selectCardGroup(a: any) {
    this.selectedCardGroup = a.target.value;
    this.showCardGroupSelectedError = false;
  }

  saveCards() {
    if (this.operation === 'move') {
      if (this.selection === 0) {
        if (this.selectedCardGroup !== undefined && this.selectedCardGroup !== 'Select Target Card Group') {
          this.showICCIDConsistOnlyNumbersError = false;
          this.defaultService.cardGroupsCardGroupIdCardsPut(this.selectedCardGroup, this.cards, toInt(this.sourceCard.cardGroupId)).subscribe(x => {
          // this.defaultService.cardGroupsGroupIdCardsPut(this.selectedCardGroup, this.cards, this.sourceCard.cardGroupId).subscribe(x => {
              let failedMoves = [];
              for (let i = 0; i < x.length; i++) {
                if(x[i]['message'] !== 'Success!'){
                  failedMoves.push(x[i]);
                }
              }

              if (failedMoves.length > 0) {
                this.step = 'step3';
                this.errorResponse = failedMoves;
              } else {
                this.action.emit(true);
                this._bsModalRef.hide();
              }
            },
            (error) => {
              console.log(error);
              this.errorHandlingService.errorHandling(error);
            });
        } else {
          this.showCardGroupSelectedError = true;
        }
      } else if (this.selection === 1) {
        if (this.selectedCardGroup && this.selectedCardGroup !== 'Select Target Card Group') {

          if (!this.rangeViccid || !this.validateeis(this.rangeViccid.toString())) {
            this.showICCIDConsistOnlyNumbersError = true;
            return;
          } else {
            this.showICCIDConsistOnlyNumbersError = false;
          }
          if (this.rangeQuantity === undefined) {
            this.showQuantityError = true;
            return;
          }

          const rangeArr = new Array<string>();
          if (this.rangeQuantity >= 0) {
            for (let i = 0; i < this.rangeQuantity; i++) {
              const splusplus = this.addition(this.rangeViccid, i);
              rangeArr.push(splusplus);
            }

          } else {
            this.showQuantityError = true;
            return;
          }

          if (rangeArr.length === 0) {
            return;
          }
          this.defaultService.cardGroupsCardGroupIdCardsPut(this.selectedCardGroup, rangeArr, toInt(this.sourceCard.cardGroupId)).subscribe(x => {
          // this.defaultService.cardGroupsGroupIdCardsPut(this.selectedCardGroup, rangeArr, this.sourceCard.cardGroupId).subscribe(x => {
              let failedMoves = [];
              for (let i = 0; i < x.length; i++) {
                if(x[i]['message'] !== 'Success!'){
                  failedMoves.push(x[i]);
                }
              }

              if (failedMoves.length > 0) {
                this.step = 'step3';
                this.errorResponse = failedMoves;
                this.action.emit(false);
              } else {
                this.action.emit(true);
                this._bsModalRef.hide();
              }
            },
            (error) => {
              console.log(error);
              this.errorHandlingService.errorHandling(error);
            });

        } else {
          this.showCardGroupSelectedError = true;
        }
      } else if (this.selection === 2) {
        if (this.selectedCardGroup && this.selectedCardGroup !== 'Select Target Card Group') {
          if (!this.uploaded) {
            this.showUploadFileError = true;
            return;
          }
          let rangeArr = [];
          this.fileText = this.fileText.replace(/\r/gi, '');
          this.fileText = this.fileText.replace(/\t/gi, '');
          rangeArr = this.fileText.split('\n');
          rangeArr = rangeArr.filter(item => item !== '');
          const finalArr = [];
          rangeArr.forEach(x => {
            finalArr.push(x.trim());
          });
          this.defaultService.cardGroupsCardGroupIdCardsPut(this.selectedCardGroup, finalArr, toInt(this.sourceCard.cardGroupId)).subscribe(x => {
              let failedMoves = [];
              for (let i = 0; i < x.length; i++) {
                if(x[i]['message'] !== 'Success!'){
                  failedMoves.push(x[i]);
                }
              }

              if (failedMoves.length > 0) {
                this.step = 'step3';
                this.errorResponse = failedMoves;
              } else {
                this.action.emit(true);
                this._bsModalRef.hide();
              }
            },
            (error) => {
              console.log(error);
              this.errorHandlingService.errorHandling(error);
            });
        } else {
          this.showCardGroupSelectedError = true;
        }
      }
    }
  }

  public addition(baseNumber: string, plus: number) {
    return bigInt(baseNumber.trim()).add(plus).toString();
  }

  public back(): void {
    this.step = 'step1';
    this.showCardGroupSelectedError = false;
    this.showICCIDConsistOnlyNumbersError = false;
    this.showUploadFileError = false;
    this.showQuantityError = false;
    this.selectedCardGroup = undefined;
    this.rangeQuantity = undefined;
    this.rangeViccid = undefined;
  }

  fileUpload(event) {
    const reader = new FileReader();
    reader.readAsText(event.srcElement.files[0]);
    const me = this;
    reader.onload = function () {
      me.fileText = reader.result;
    };
    if (reader.onload) {
      this.uploaded = true;
      this.showUploadFileError = false;
    } else {
      this.uploaded = false;
      this.showUploadFileError = true;
    }
  }

  close() {
    this.action.emit(true);
    this._bsModalRef.hide();
  }

  closeError() {
    this.action.emit(false);
    this._bsModalRef.hide();
  }

  validateeis(eis: string) {
    return /^\d+$/.test(eis);
  }
}



// WEBPACK FOOTER //
// ./src/app/achelos-iot/modals/selection-operation-modal/selection-operation-modal.component.ts